/* eslint-disable react/no-unescaped-entities */
import React from 'react';

import { Box, Image } from '@chakra-ui/react';

import SlackPlugin from 'assets/assetsV1/illustrations/SlackPlugin.jpg';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { NumberIconSteps, StepCard } from '../commonComponents';

const InstallationSection = () => (
  <StepCard
    title="Installation Steps"
    rightComp={
      <Box
        border="1px solid"
        borderColor="feedback.E7DAFF"
        borderRadius="8px"
        overflow="hidden"
        width="45%"
        p={8}
        bg="#F8F8FF"
      >
        <Image src={SlackPlugin} objectFit="cover" width="100%" height="100%" />
      </Box>
    }
  >
    <Box>
      <NumberIconSteps
        stepsComps={[
          <TextBodyMedium>
            Click the <b>"Install"</b> button.
          </TextBodyMedium>,

          <TextBodyMedium>
            Login to your Slack website & click on <b>"Allow"</b>
          </TextBodyMedium>,

          <TextBodyMedium>
            Choose Mesh notifications that you want to <b>"receive"</b> on Slack
          </TextBodyMedium>,
        ]}
      />
    </Box>
  </StepCard>
);

export { InstallationSection };
